// extracted by mini-css-extract-plugin
module.exports = {"EmployerFAQ":"_3BynX2MX","content":"_30hmeF1R","question":"_3vikXc8-","answer":"_2ARIm4z0","supportText":"_8UCdCD6n","bold":"_2Pi-nTAV"};
    if(module.hot) {
      // 1746735762523
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  